module.exports = __webpack_public_path__ + "56ab8a103d4bdd2f175b2e80db603b7c.svg";